<template>
  <div id="app">
    <ManualView />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import ManualView from '@/views/manual/index.vue'

export default Vue.extend({
  components: {
    ManualView,
  },
})
</script>

<style lang="less">
:root {
  --primary-color: #007bff;
  --primary-hover: #0056b3;
  --text-primary: #333;
  --text-secondary: #666;
  --text-muted: #999;
  --bg-white: #fff;
  --bg-light: #f4f4f4;
  --bg-lighter: #f8f9fa;
  --bg-code: #2d2d2d;
  --border-light: #ddd;
  --border-medium: #dee2e6;
  --border-dark: #ccc;
  --code-pink: #d63384;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body,
#app {
  width: 100%;
  min-height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-primary);
  background-color: var(--bg-white);
}

h1 {
  font-size: 28px;
  line-height: 1.4;
  margin: 30px 0 15px;
}

h2 {
  font-size: 24px;
  line-height: 1.4;
  margin: 25px 0 12px;
}

h3 {
  font-size: 20px;
  line-height: 1.4;
  margin: 20px 0 10px;
}

h4 {
  font-size: 18px;
  line-height: 1.4;
  margin: 15px 0 8px;
}

p {
  margin: 10px 0;
  line-height: 1.8;
}

ul,
ol {
  margin: 10px 0;
  padding-left: 30px;
}

li {
  margin: 5px 0;
  line-height: 1.8;
}

code {
  background-color: var(--bg-light);
  padding: 2px 5px;
  border-radius: 3px;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  font-size: 14px;
  color: var(--code-pink);
}

pre {
  background-color: var(--bg-code);
  color: #f0f0f0;
  padding: 15px;
  border-radius: 5px;
  overflow-x: auto;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.6;
  margin: 15px 0;
}

pre code {
  background-color: transparent;
  padding: 0;
  color: inherit;
}

a {
  color: var(--primary-color);
  text-decoration: underline;
}

a:hover {
  color: var(--primary-hover);
}

table {
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0;
  font-size: 14px;
}

th,
td {
  border: 1px solid var(--border-medium);
  padding: 12px;
  text-align: left;
}

th {
  background-color: var(--bg-lighter);
  font-weight: bold;
}
</style>
